class StoreLocator extends HTMLElement {
  constructor() {
    super();

    this.searchInput = this.querySelector('input[name="zipcode"]');
    this.searchForm = this.querySelector('form');
    this.stockistContainer = document.getElementById('stockist-widget');
    
    this.init();
  }

  init() {
    this.setupEventListeners();
    this.waitForStockistWidget();
  }

  setupEventListeners() {
    // Prevent form submission and handle search manually
    this.searchForm?.addEventListener('submit', (e) => {
      e.preventDefault();
      this.handleSearch();
    });

    // Handle real-time input syncing
    this.searchInput?.addEventListener('input', (e) => {
      this.syncWithStockistSearch(e.target.value);
    });
  }

  waitForStockistWidget() {
    // Check if Stockist widget is already loaded
    if (typeof Stockist !== 'undefined' && Stockist.loaded) {
      this.onStockistWidgetLoaded();
    } else {
      // Wait for the Stockist widget to load
      window.addEventListener('load', () => {
        // Give the widget time to load
        const checkStockistLoaded = setInterval(() => {
          if (typeof Stockist !== 'undefined' && Stockist.loaded) {
            clearInterval(checkStockistLoaded);
            this.onStockistWidgetLoaded();
          }
        }, 100);
        
        // Set a timeout to prevent infinite checking
        setTimeout(() => {
          clearInterval(checkStockistLoaded);
          console.warn('Stockist widget failed to load within timeout');
        }, 10000);
      });
    }
  }

  onStockistWidgetLoaded() {
    if (this.searchInput?.value) {
      setTimeout(() => {
        this.syncWithStockistSearch(this.searchInput.value);
      }, 1000);
    }
  }

  handleSearch() {
    const searchValue = this.searchInput?.value || '';
    
    if (typeof Stockist === 'undefined' || !Stockist.__widget?._form?._element) {
      console.warn('Stockist widget form not available');
      return;
    }

    // First sync the search value
    this.syncWithStockistSearch(searchValue);

    // Then trigger the form submission
    const form = Stockist.__widget._form._element;
    form.dispatchEvent(new Event('submit', { bubbles: true }));
  }

  syncWithStockistSearch(value) {
    if (typeof Stockist === 'undefined' || !Stockist.__widget?._form?._input) {
      console.warn('Stockist widget form not available');
      return;
    }

    // Set the value and trigger the input event
    const input = Stockist.__widget._form._input;
    input.value = value;
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }
}

// Register the custom element
customElements.define('store-locator', StoreLocator);
